<template>
  <div class="kpi-card-wrapper">
    <PrimaryCard>
      <CardTooltip
        :tooltip="tooltip"
      />
      <Icon
        v-if="showExpandIcon"
        small
        :color="iconColor"
        class="kpi-expand-icon"
        @click="emitIconClick"
      >
        mdi-open-in-new
      </Icon>
      <div class="kpi-card">
        <KpiCardContent
          :data="data"
          :metric="metric"
          :loading="loading"
          :error="error"
          :hideRateChange="hideRateChange"
          :customName="customName"
        />
      </div>
    </PrimaryCard>
  </div>
</template>

<script>
import { PrimaryCard, Icon } from '@mikmak/components';
import CardTooltip from '../Tooltips/CardTooltip/index.vue';
import KpiCardContent from './KpiCardContent.vue';

export default {
  components: {
    PrimaryCard,
    CardTooltip,
    KpiCardContent,
    Icon,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    metric: {
      type: String,
      required: true,
    },
    tooltip: String,
    loading: Boolean,
    error: Boolean,
    hideRateChange: Boolean,
    showExpandIcon: Boolean,
    customName: String,
  },
  data() {
    return {
      iconColor: '#4369F4',
    };
  },
  methods: {
    emitIconClick() {
      this.$emit('iconClick');
    },
  },
};

</script>

<style lang="scss" scoped>

.kpi-card-wrapper {
  font-family: Lato;
  flex: 1 1 0;
  margin: 16px 8px;
  position: relative;

  & ::v-deep .main-card-wrapper.primary {
    background-color: rgba(67, 105, 244, 0.1);
    border: 1px solid #9DB4FB;
    height: 111px;
    padding: 8px;
    box-shadow: none;
  }
}

.kpi-card {
  height: 111px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.kpi-expand-icon {
  position: absolute;
  top: 8px;
  right: 8px;
}

</style>
